var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-title',[_vm._v(" Batches list ")]),_c('v-card-text',[_c('BatchesList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }